import {Actions} from './actions';
import {AssetsAction, AssetsState} from './types';

export const assetsInitialState: AssetsState = {
  isFetched: false,
  company: null,
  roles: [],
  users: [],
  nodes: [],
  maps: [],
  layers: [],
  color: [],
  sound: [],
  machine_types: [],
  asset_human_types: [],
  shifts: [],
  zones: [],
  sites: [],
  asset_machines: [],
  asset_humans: [],
  asset_human_groups: [],
  machine_inputs: [],
  eventBaseTypes: [],
  constants: null,
  humanAlertType: [],
  communicationNodeType: [],
  dashboardsFavourite: [],
  dashboardsPrimary: [],
  dashboardList: [],
  machineAlertType: [],
  subscriptionReportType: [],
  wifiPointType: [],
  commtrac_nodes: [],
  alarm_modules: [],
  localButtonPressAction: [],
  alarm_groups: [],
  activationReason: [],
  safeye_nodes: [],
  ams_nodes: [],
  ams_emodules: [],
  belt_nodes: [],
  emoduleTypeIdLabel: null,
  belt: null,
  belts: [],
  default_dashboard: [],
  sentro8ChannelLabel: null,
  emoduleTypeIconName: null,
};

const assetsReducers = (state?: AssetsState, action?: AssetsAction) => {
  state = state ?? assetsInitialState;
  switch (action?.type) {
    case Actions.SetAssets:
      return {...state, ...action.data};

    default:
      return state;
  }
};

export default assetsReducers;
